<template>
  <div>
    <el-button type="primary" @click="openDialog">
      选择关联频控</el-button
    >
    <el-button @click="handleCleanAll" :disabled="cleanBtnDisabled">清空</el-button>
    <el-dialog
      title="选择需要联合频控的计划单"
      :visible.sync="dialogVisible"
      width="80%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :inline="true">
        <div class="order-search-item">
          <el-form-item label="所属订单" prop="orderNoOrName" :rules="[{ required: true, message: '所属订单必填' }]">
            <el-input v-model="form.orderNoOrName" clearable placeholder="请输入订单编号或订单名称查询" @keyup.enter.native="handleSearch"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="计划单号">
          <el-input v-model="form.scheduleNo" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="计划名称">
          <el-input v-model="form.scheduleName" clearable @keyup.enter.native="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="计划状态">
          <el-select
            v-model="form.scheduleStatus"
            clearable
            placeholder="请选择"
            class="demo-form-select"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button @click="handeReset">重置</el-button>
      </el-form>
      <div style="margin: 16px"></div>
      <Table
        v-loading="loading"
        :props="table.props"
        ref="table"
        style="border-right: 1px solid #EBEEF5"
        :header="table.header.filter((item) => item.show)"
        :data="table.data"
        :selected="table.selected"
        :selection-type="table.selectionType"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
      />

      <span slot="footer" class="dialog-footer">
        <el-row>
          <el-col :span="12">
            <pagination
              style="float: left"
              v-bind:currentpage="currentPage"
              v-bind:pagesize="pageSize"
              v-bind:totalcount="totalCount"
              @handle-size-change="handleSizeChange"
              @handle-current-change="handleCurrentChange"
            ></pagination>
          </el-col>
          <el-col :span="12">
            已选 <span style="color: #FF8B00;padding:0 5px">{{ selectedRow.length }} </span>条
            <el-button
              type="primary"
              :disabled="selectedRow.length === 0"
              @click="handleConfirm"
              >确 定</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const scheduleStatusOptions = [
  {
    label: '草稿',
    value: 1
  },
  {
    label: '待审核',
    value: 2
  },
  {
    label: '待投放',
    value: 3
  },
  {
    label: '投放中',
    value: 4
  },
  {
    label: '已下线',
    value: 5
  },

  {
    label: '暂停',
    value: 9
  }
]
export default {
  props: {
    orderNo: {
      type: String
    },
    scheduleInfo: {
      type: Object
    },
    cleanBtnDisabled: {
      type: Boolean,
      deafult: false
    }
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      form: this.genDefaultForm(),
      dialogVisible: false,
      options: scheduleStatusOptions,
      table: {
        props: {
          border: true,
          'tooltip-effect': 'dark'
        },
        header: [
          {
            prop: 'scheduleNo',
            label: '计划单号',
            show: true,
            'min-width': '150',
            'show-overflow-tooltip': true
          },
          {
            prop: 'scheduleName',
            label: '计划名称',
            show: true,
            'min-width': '160',
            'show-overflow-tooltip': true
          },
          {
            prop: 'spaceName',
            label: '广告位',
            show: true,
            'min-width': '120'
          },
          {
            prop: 'frequency',
            label: '频次控制',
            show: true,
            'min-width': '120',
            formatter: params => {
              return this.$consts.frequencyText[params.frequency] + params.trafficDaily + '次'
            }
          },
          {
            prop: 'subFrequency',
            label: '双周期频控',
            show: this.scheduleInfo && this.scheduleInfo.subFrequency !== 1,
            'min-width': '120',
            formatter: params => {
              return params.subFrequency !== 1
                ? this.$consts.frequencyText[params.subFrequency] + params.subTrafficDaily + '次'
                : this.$consts.frequencyText[params.subFrequency]
            }
          },
          {
            prop: 'scheduleStatus',
            label: '状态',
            show: true,
            formatter: params => {
              return this.$consts.shceduleStatusText[params.scheduleStatus]
            }
          },
          {
            prop: 'scheduleId',
            label: '计划ID',
            show: false
          },
          {
            prop: 'orderNo',
            label: '订单编号',
            show: true,
            'min-width': '150'
          },
          {
            prop: 'orderName',
            label: '订单名称',
            show: true,
            'min-width': '160'
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      selected: [],
      selectedRow: []
    }
  },
  watch: {
    dialogVisible(newValue, oldValue) {
      if (newValue) {
        this.handleSearch()
      }
      this.selectedRow = []
      this.table.selected = []
      this.table.data = []
      this.selected = []
      this.form = this.genDefaultForm()
    }
  },
  methods: {
    openDialog() {
      if (this.scheduleInfo.unionFreqType === 2 && !this.scheduleInfo.trafficDaily) {
        return this.$message.error('请先填写频次')
      }
      this.dialogVisible = true
    },
    genDefaultForm() {
      return {
        orderNoOrName: this.orderNo,
        scheduleNo: undefined,
        scheduleName: undefined,
        scheduleStatus: undefined
      }
    },
    fetchData() {
      this.loading = true
      if (!this.form.orderNoOrName) {
        this.loading = false
        return this.$message.error('必须填写计划所属订单！')
      }
      const filter = {
        ...this.form,
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        scheduleId: this.scheduleInfo.scheduleId,
        channelId: this.scheduleInfo.channelId,
        frequency: this.scheduleInfo.frequency,
        subFrequency: this.scheduleInfo.subFrequency === 1 ? undefined : this.scheduleInfo.subFrequency,
        unionSequence: this.scheduleInfo.unionSequence
      }
      // 有顺序的关联频控，计划单频次必须一致
      if (this.scheduleInfo.unionSequence === 1) {
        filter.trafficDaily = parseInt(this.scheduleInfo.trafficDaily)
        filter.subTrafficDaily = this.scheduleInfo.subFrequency === 1 ? undefined : parseInt(this.scheduleInfo.subTrafficDaily)
      }
      this.$service.getUnionPageList(filter).then(data => {
        this.table.data = data.rows || []
        this.totalCount = data.total || 0
        this.updateTableSelected()
        this.loading = false
      })
        .catch(() => {
          this.loading = false
        })
    },

    // 每页显示数据量变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleRowSelectionAdd(targetItem) {
      this.selected.push(targetItem.scheduleId)
      this.selectedRow.push(targetItem)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(targetItem) {
      this.selected = this.selected.filter(item => {
        return item !== targetItem.scheduleId
      })
      this.selectedRow = this.selectedRow.filter(item => {
        return item.scheduleId !== targetItem.scheduleId
      })
      this.updateTableSelected()
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        this.selected = []
        this.selectedRow = []
        this.table.selected = []
      }
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.scheduleId) > -1) {
          result.push(index)
        }
        return result
      }, [])
    },
    handleSearch() {
      this.currentPage = 1
      this.fetchData()
    },
    handeReset() {
      this.form = this.genDefaultForm()
      this.pageSize = 10
      this.fetchData()
    },
    handleCleanAll() {
      this.$emit('clean-all', true)
    },
    handleConfirm() {
      const scheduleNos = this.selectedRow.map(item => {
        return item.scheduleNo
      })
      this.$service.getUnionScheduleList(scheduleNos).then(data => {
        const arr = this.selectedRow.concat(data || [])
        this.$emit('confirm', arr)
        this.dialogVisible = false
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.order-search-item
  margin-bottom 16px
  .el-form-item
    width 50%
    >>>.el-form-item__content
      width calc(100% - 80px)
</style>
